import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  stroke: "#fff",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 15",
  style: {"stroke-width":".5","left":"1px"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M.66.633a.5.5 0 0 1 .707.028l6 6.5a.5.5 0 0 1 0 .678l-6 6.5a.5.5 0 1 1-.734-.678L6.32 7.5.633 1.34A.5.5 0 0 1 .66.632Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }